import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink } from 'reactstrap';
import PropTypes from 'prop-types';

import { AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
import { logOutUser, USER_ROLES } from '../../modules/agent';
import logo from '../../assets/img/brand/logo.jpg'
import sygnet from '../../assets/img/brand/logo.jpg'
import logo2 from '../../assets/img/brand/ncl-logo-hrz.png'
import sygnet2 from '../../assets/img/brand/ncl-logo-hrz.png'

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultHeader extends Component {

  render() {
    const { user } = this.props;
    const hasAgency = user && user.roles && user.roles.includes(USER_ROLES.ADMIN);

    // eslint-disable-next-line
    const { children, logOutUser, ...attributes } = this.props;

    return (
      <React.Fragment>

        <AppSidebarToggler className="d-md-down-none" display="lg" />

        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <AppNavbarBrand
          full={{ src: logo, width: 89, height: 25, alt: 'CoreUI Logo' }}
          minimized={{ src: sygnet, width: 30, height: 30, alt: 'CoreUI Logo' }}
        />
        <AppNavbarBrand
          full={{ src: logo2, width: 140, height: 25, alt: 'CoreUI Logo' }}
          minimized={{ src: sygnet2, width: 40, height: 30, alt: 'CoreUI Logo' }}
        />

        <Nav className="d-sm-down-none" navbar>
          <NavItem className="px-3">
            <NavLink href="/">Dashboard</NavLink>
          </NavItem>
          <AppHeaderDropdown className="px-3" style={{ right: 20 }} direction="down">
            <DropdownToggle nav>
              Settings
            </DropdownToggle>
            <DropdownMenu right style={{ right: 'auto' }}>
              {
                hasAgency && (
                  <RouterNavLink className="text-dark link-button" to={`/agency-profile`}>
                    <DropdownItem>
                      <i className="fa fa-user"></i>Agency Profile
                      </DropdownItem>
                  </RouterNavLink>
                )
              }
              <RouterNavLink className="text-dark link-button" to="/agent-profile">
                <DropdownItem>
                  <i className="fa fa-user"></i>Agent Profile
                </DropdownItem>
              </RouterNavLink>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
        <Nav className="ml-auto" navbar>
          {/*<NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-bell"></i><Badge pill color="danger">5</Badge></NavLink>
          </NavItem>
          <NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-list"></i></NavLink>
          </NavItem>
          <NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-location-pin"></i></NavLink>
          </NavItem>*/}
          <AppHeaderDropdown style={{ right: 20 }} direction="down">
            <DropdownToggle nav>
              <img src={'assets/img/avatars/default-user.png'} className="img-avatar" alt="admin@bootstrapmaster.com" />
            </DropdownToggle>
            <DropdownMenu right style={{ right: 'auto' }}>
              {/*<DropdownItem header tag="div" className="text-center"><strong>Account</strong></DropdownItem>
              <DropdownItem><i className="fa fa-bell-o"></i> Updates<Badge color="info">42</Badge></DropdownItem>
              <DropdownItem><i className="fa fa-envelope-o"></i> Messages<Badge color="success">42</Badge></DropdownItem>
              <DropdownItem><i className="fa fa-tasks"></i> Tasks<Badge color="danger">42</Badge></DropdownItem>
              <DropdownItem><i className="fa fa-comments"></i> Comments<Badge color="warning">42</Badge></DropdownItem>
              <DropdownItem header tag="div" className="text-center"><strong>Settings</strong></DropdownItem>
              <DropdownItem><i className="fa fa-user"></i> Profile</DropdownItem>
              <DropdownItem><i className="fa fa-wrench"></i> Settings</DropdownItem>
              <DropdownItem><i className="fa fa-usd"></i> Payments<Badge color="secondary">42</Badge></DropdownItem>
              <DropdownItem><i className="fa fa-file"></i> Projects<Badge color="primary">42</Badge></DropdownItem>
              <DropdownItem divider />
              <DropdownItem><i className="fa fa-shield"></i> Lock Account</DropdownItem>*/}
              <DropdownItem onClick={logOutUser}><i className="fa fa-lock"></i> Logout</DropdownItem>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
        {/*<AppAsideToggler className="d-md-down-none" />*/}
        {/*<AppAsideToggler className="d-lg-none" mobile />*/}
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

const mapDispatchToProps = dispatch => bindActionCreators({
  logOutUser,
}, dispatch);

const mapStateToProps = state => ({
  user: state.auth.user,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DefaultHeader);



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultHeader.js